import { useEffect, useState } from 'react';
import { listSellerProfiles } from '../api/admin/sellerProfiles';

/**
 * Выбор варианта реквизитов для формирования документов.
 * Пустое value = default на бэке.
 */
export default function SellerProfileSelect({ value, onChange, className }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const list = await listSellerProfiles({ active: 1 });
        if (cancelled) return;
        setItems(list);
        if (!value && list.length) {
          const def = list.find((x) => x.isDefault) || list[0];
          if (def) onChange(def._id);
        }
      } catch {
        /* ignore — бэк подставит default */
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <label className={className} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      Реквизиты:
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading || !items.length}
      >
        {!items.length && <option value="">{loading ? 'Загрузка…' : 'Нет вариантов'}</option>}
        {items.map((it) => (
          <option key={it._id} value={it._id}>
            {it.title}{it.isDefault ? ' (default)' : ''}
            {it.recipientName ? ` — ${it.recipientName}` : ''}
          </option>
        ))}
      </select>
    </label>
  );
}
